"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    diffNetwork: -77777,
    noResponse: -88888
};
//# sourceMappingURL=code.js.map